module.exports = __webpack_public_path__ + "img/txt.4786116c.png";